import { Chip, Sheet, Table, Typography } from '@mui/joy';
import { formatMoney } from './adsConstants';

/**
 * Справочная сетка цен по типу охвата. activeScope подсвечивает строку,
 * соответствующую текущему таргетингу.
 */
export default function AdGeoPricing({ pricing, activeScope }) {
    if (!pricing || !pricing.length) return null;
    return (
        <Sheet variant="outlined" sx={{ p: 2, borderRadius: 'md', mt: 2 }}>
            <Typography level="title-sm" sx={{ mb: 0.5 }}>Стоимость по охвату</Typography>
            <Typography level="body-xs" color="neutral" sx={{ mb: 1 }}>
                Чем шире география, тем выше минимальная ставка. Тип охвата берётся из таргетинга.
            </Typography>
            <Table size="sm" sx={{ '--TableCell-paddingY': '6px' }}>
                <thead>
                    <tr><th>Охват</th><th>Множитель</th><th>Мин. за клик</th><th>Мин. за 1000</th></tr>
                </thead>
                <tbody>
                    {pricing.map((p) => (
                        <tr key={p.scope}
                            style={p.scope === activeScope
                                ? { background: 'var(--joy-palette-primary-softBg)' } : undefined}>
                            <td>
                                {p.label}
                                {p.scope === activeScope && (
                                    <Chip size="sm" color="primary" variant="soft" sx={{ ml: 1 }}>ваш</Chip>
                                )}
                            </td>
                            <td>×{p.multiplier}</td>
                            <td>{formatMoney(p.min_cpc)} ₽</td>
                            <td>{formatMoney(p.min_cpm)} ₽</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Sheet>
    );
}